module.exports = __webpack_public_path__ + "res/ic_reset.7865b613f14c61d1833ffcbfbaee6f5f.png";